import { pluginDefaultPriority } from '../constants.js';
/**
 * 将 plugin 优先级高的排在前面，
 * 对于 name 重复的给予提示并移除
 */
export function sortUnique(plugins) {
    const sorted = [...plugins]
        .sort((a, b) => {
        var _a, _b;
        const aPriority = (_a = a.priority) !== null && _a !== void 0 ? _a : pluginDefaultPriority;
        const bPriority = (_b = b.priority) !== null && _b !== void 0 ? _b : pluginDefaultPriority;
        return bPriority - aPriority;
    })
        .filter((plugin, _i, array) => {
        if (array.find((p) => p.name === plugin.name) !== plugin) {
            console.warn(`Duplicate plugin named "${plugin.name}" ignored`);
            return false;
        }
        return true;
    });
    return sorted;
}
//# sourceMappingURL=plugin.js.map